import script from "./IndustrialInspection.vue?vue&type=script&setup=true&lang=js"
export * from "./IndustrialInspection.vue?vue&type=script&setup=true&lang=js"

import "./IndustrialInspection.vue?vue&type=style&index=0&id=2c47a278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c47a278"]])

export default __exports__